import { render, staticRenderFns } from "./WhiteList.vue?vue&type=template&id=b30b67e2&"
import script from "./WhiteList.vue?vue&type=script&lang=ts&"
export * from "./WhiteList.vue?vue&type=script&lang=ts&"
import style0 from "./WhiteList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports